import Icon from './Icon';
import type { IconName } from '@/theme/icons';

/**
 * Ported from src/components/ui/ListRow.tsx, prop for prop: an icon, a label, and the
 * chevron that appears unless the row is an accent or destructive action.
 */
export default function ListRow({
  icon,
  label,
  onPress,
  accent = false,
  destructive = false,
  chevron,
  divider = false,
  disabled = false,
}: {
  icon: IconName;
  label: string;
  onPress: () => void;
  accent?: boolean;
  destructive?: boolean;
  chevron?: boolean;
  divider?: boolean;
  /** Shown, not pressable: an action that is unsafe for now, said beside it by the caller. */
  disabled?: boolean;
}) {
  const showChevron = chevron ?? !(destructive || accent);
  const tone = destructive ? 'destructive' : accent ? 'accent' : 'default';
  return (
    <button
      type="button"
      onClick={onPress}
      disabled={disabled}
      className={`list-row list-row-${tone} pressable ${divider ? 'list-row-divider' : ''}`.trim()}
    >
      <Icon name={icon} size={20} />
      <span className="list-row-label type-body">{label}</span>
      {showChevron && <Icon name="chevron" size={18} color="var(--color-chevron)" />}
    </button>
  );
}
